import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltungs-typ-admin-rolle-entfernen';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypAdminRolleEntfernenEffects {

    VeranstaltungsTypAdminRolleEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNGS_TYP_ADMIN_ROLLE_ENTFERNEN),
        mergeMap((x: ac.PostVeranstaltungsTypAdminRolleEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungsTypAdminRolleEntfernen(x.veranstaltungsTypRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungsTypAdminRolleEntfernenErfolgreichAction(result, x.veranstaltungsTypRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungsTypAdminRolleEntfernenFehlerAction(error, x.veranstaltungsTypRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenCommandService);
        }
        return this.service;
    }
}
